/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Card, Typography, Row, Col, Space, Button } from "antd";
import { EnvironmentFilled, PhoneFilled } from "@ant-design/icons";
import {
	darkGrey,
} from "../GlobalConfig";
import { isMobile } from "react-device-detect";

const { Text } = Typography;

const LocationCard = ({
	// id,
	name,
	phone,
	logo,
	location,
	coverPhoto,
	themeColor,
	// businessFeatures,
	// border,
	hover,
	hideBookButton,
}) => {
	const PracticeAddress = ({ fullAddress }) => (
		<>
			{fullAddress && (
				<Space align="start">
					<EnvironmentFilled
						style={{ color: themeColor ? themeColor : darkGrey, fontSize: 16 }}
					/>
					<Text type="secondary" style={{ fontSize: 13 }}>
						{fullAddress.split(/\n\n/).map((line, i) => (
							<span key={i}>
								{line}
								{i < fullAddress.split(/\n\n/).length - 1 && <br />}
							</span>
						))}
					</Text>
				</Space>
			)}
		</>
	);

	const coverHeight = isMobile ? 120 : 160;

	return (
		<div style={{ maxWidth: 500, margin: "0 auto", marginBottom: isMobile ? 16 : 24 }}>
			<Card
				className="location-card"
				hoverable={hover}
				style={{ overflow: "hidden", borderRadius: 8 }}
				bodyStyle={{ padding: 0 }}
				cover={
					coverPhoto ? (
						<img
							alt={name}
							style={{
								objectFit: "cover",
								width: "100%",
								height: coverHeight,
								display: "block",
							}}
							src={coverPhoto}
						/>
					) : (
						<div
							style={{
								backgroundColor: themeColor ? themeColor : darkGrey,
								height: coverHeight,
								width: "100%",
							}}
						/>
					)
				}
			>
				<div style={{ padding: isMobile ? "12px 16px 16px" : "16px 24px 20px" }}>
					{/* Logo + Name row */}
					<Row align="middle" gutter={[12, 0]} style={{ marginBottom: 12 }}>
						{logo?.url && (
							<Col flex="none">
								<img
									alt="Practice Logo"
									src={logo.url}
									style={{
										maxWidth: 56,
										maxHeight: 56,
										borderRadius: 6,
										objectFit: "contain",
										border: "1px solid #f0f0f0",
										padding: 4,
										background: "#fff",
									}}
								/>
							</Col>
						)}
						<Col flex="auto">
							<Typography.Title level={5} style={{ margin: 0 }}>
								{name}
							</Typography.Title>
						</Col>
					</Row>

					{/* Address */}
					<div style={{ marginBottom: 8 }}>
						<PracticeAddress {...location} />
					</div>

					{/* Phone */}
					{phone && (
						<Space align="center" style={{ marginBottom: 4 }}>
							<PhoneFilled
								style={{ color: themeColor ? themeColor : darkGrey, fontSize: 16 }}
							/>
							<Text type="secondary" style={{ fontSize: 13 }}>
								{phone}
							</Text>
						</Space>
					)}

					{/* Book Now button */}
					{!hideBookButton && (
						<Button
							block
							size="large"
							style={{
								marginTop: 16,
								background: themeColor ? themeColor : "#000",
								color: "white",
								border: "none",
								borderRadius: 6,
								fontWeight: 500,
							}}
						>
							Book Now
						</Button>
					)}
				</div>
			</Card>
		</div>
	);
};

export default LocationCard;
